module.exports = __webpack_public_path__ + "assets/img/role-28dcbf46.png";